/// <reference path="../_all.ts" />

declare var moment: any;


module user {
  'use strict';

  export class DateLocaleProvider {
    
    public static $inject = [
      '$mdDateLocaleProvider', 
      '$localeProvider',
    ];

    constructor(
      $mdDateLocaleProvider: ng.material.IDateLocaleProvider
      , $localeProvider : any
      ) { 

      https://github.com/angular/angular.js/wiki/Understanding-Dependency-Injection#configuring-providers
      // Only providers for services can be injected in config blocks
      var locale = $localeProvider.$get();

      $mdDateLocaleProvider.months = locale.DATETIME_FORMATS.MONTH;
      $mdDateLocaleProvider.shortMonths = locale.DATETIME_FORMATS.SHORTMONTH;
      $mdDateLocaleProvider.days = locale.DATETIME_FORMATS.DAY;
      $mdDateLocaleProvider.shortDays = locale.DATETIME_FORMATS.SHORTDAY;

      // Can change week display to start on Monday.
      $mdDateLocaleProvider.firstDayOfWeek = 1;
            
      moment.locale(locale.id);
      moment.defaultFormat = locale.DATETIME_FORMATS.shortDate;
      moment.defaultFormatUtc = locale.DATETIME_FORMATS.shortDate;

      // Example uses moment.js to parse and format dates.
      $mdDateLocaleProvider.parseDate = function(dateString) {
        var m = moment(dateString, 'L', true); 
        return m.isValid() ? m.toDate() : new Date(NaN);
      };

      $mdDateLocaleProvider.formatDate = function(date) {
        var m = moment(date);
        return m.isValid() ? m.format('L') : '';
      };

      // Allow only a day and month to be specified.
      // This is required if using the 'M/D' format with moment.js.
      //$mdDateLocaleProvider.isDateComplete = function(dateString) {
      //  dateString = dateString.trim();

      //  // Look for two chunks of content (either numbers or text) separated by delimiters.
      //  var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-]))([a-zA-Z]{3,}|[0-9]{1,4})/;
      //  return re.test(dateString);
      //};

      $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
        return $mdDateLocaleProvider.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
      };

      // In addition to date display, date components also need localized messages
      // for aria-labels for screen-reader users.

      $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
        return 'Woche ' + weekNumber;
      };

      $mdDateLocaleProvider.msgCalendar = 'Kalender';
      $mdDateLocaleProvider.msgOpenCalendar = 'Kalender öffnen';

      // You can also set when your calendar begins and ends.
      //$mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
      //$mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
    }

    
  }
  
}